<br />
<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Informe De Gestión Vendedor</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="contenedor-form">
    <form
      [formGroup]="ventasGroup"
      (ngSubmit)="busqueda()"
      class="example-form"
    >
      <div class="row">
        <div class="col s12 m6 l2">
          <span *ngIf="loadingAgencias">
            <mat-spinner
              [diameter]="30"
              style="margin:0 auto; top:15px;"
            ></mat-spinner>
          </span>
          <span *ngIf="!loadingAgencias">
            <mat-form-field>
              <mat-label>AGENCIA</mat-label>
              <mat-select
                formControlName="idAgencia"
                (change)="cargarUsuariosAgencia()"
              >
                <mat-option
                  *ngFor="let agencia of agencias"
                  [value]="agencia.id"
                >
                  {{ agencia.valor }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </span>
        </div>
        <div class="col s12 m6 l4">
          <span *ngIf="loadingUsuarios">
            <mat-spinner
              [diameter]="30"
              style="margin:0 auto; top:15px;"
            ></mat-spinner>
          </span>
          <span *ngIf="!loadingUsuarios">
            <mat-form-field class="example-full-width">
              <input
                matInput
                placeholder="Vendedor"
                [matAutocomplete]="auto"
                formControlName="usuarioCtrl"
              />
              <mat-autocomplete
                #auto="matAutocomplete"
                [displayWith]="displayFn"
              >
                <mat-option
                  *ngFor="let usuario of filteredUsuarios | async"
                  [value]="usuario"
                >
                  <span>{{ usuario.valor }}</span>
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </span>
        </div>
        <div class="col s12 m6 l2">
          <mat-form-field>
            <input
              formControlName="fechaInicial"
              readonly
              matInput
              [matDatepicker]="picker"
              placeholder="Fecha Inicial"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col s12 m6 l2">
          <mat-form-field>
            <input
              formControlName="fechaFinal"
              readonly
              matInput
              [matDatepicker]="picker1"
              placeholder="Fecha Final"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="picker1"
            ></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col s12 m6 l2">
          <button
            mat-raised-button
            color="accent"
            type="submit"
            [disabled]="!ventasGroup.valid || loading"
          >
            Consultar
          </button>
        </div>
      </div>
    </form>
  </div>
</mat-expansion-panel>

<br>
<mat-expansion-panel expanded="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <h6 class="titulo-solicitud">Resultados</h6>
      </mat-panel-title>
    </mat-expansion-panel-header>
    
    <div class="contenedor-form" *ngIf="loading">
        <mat-spinner
          [diameter]="100"
          style="margin:0 auto; top:15px;"
        ></mat-spinner>
      </div>

      <table
      
    [hidden]="!haveData"
    datatable
    
    [dtTrigger]="dtTrigger"
    class="display"
    style="width:100%"
  >
    <thead>
      <tr>
        <th>Detalle</th>        
        <th>Documento</th>
        <th>Fecha</th>
        <th>NIT</th>
        <th>Cliente</th>
        <th>Vendedor</th>
        <th>Valor Neto</th>
        <th>Valor Bruto</th>         
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of dataVentas">
        <td style="text-align: center;">                    
          <mat-icon style="color: gray; cursor: pointer;" matTooltip="VER DETALLE" matTooltipPosition="above" (click)="verDetalle(item);">search</mat-icon>
        </td>      
        <td style="text-align: center;">{{ item.documento }}</td>  
        <td>{{ item.fecha  | date:'yyyy-MM-dd' }}</td>
        <td>{{ item.codigo }}</td>
        <td>{{ item.cliente }}</td>
        <td>{{ item.vendedor }}</td>
        <td>{{ item.valorNeto | currency: '$':'symbol':'1.0-0'}}</td>
        <td>{{ item.valorBruto | currency: '$':'symbol':'1.0-0'}}</td>        
      </tr>
    </tbody>
  </table>
    
  </mat-expansion-panel>